export const routes = {
    HOME: '/',
    DASHBOARD: '/dashboard',
    AUTH: '/auth',
    SALESFORCE_AUTH: '/auth/salesforce',
    SHIFTER_HOME: '/shift-er',
    TERMS_OF_SERVICE : '/terms-of-service',
    COOKIE_POLICY: '/cookie-policy'
}